import { useHistory } from "react-router-dom";

const ResetPasswordInvalid = () => {
    const { push } = useHistory();

    return (
        <div className='w-100'>
            <p className="fw-bold fs-4 mb-2">Link Tidak Valid</p>
            <div className='font-sm d-flex mb-4'>
                <div className='me-2 text-secondary'>
                    Link reset password yang Anda gunakan tidak valid atau sudah tidak berlaku.
                    <br />
                    Silakan kirim ulang permintaan reset password.
                </div>
            </div>
            <div className="d-grid gap-2">
                <button
                    className="btn btn-primary font-sm"
                    type="button"
                    onClick={() => push('/lupa-password')}
                >
                    Kirim Ulang Reset Password
                </button>
            </div>
        </div>
    );
};

export default ResetPasswordInvalid;
